const popModalButton = document.querySelector('#pop-club-quick-buy3');

if (popModalButton != null) {
  popModalButton.addEventListener('click', function (e) {

    this.setAttribute('disabled', 'true');
    nonCartIframeOpen();

  });
}

// Close Button
const spanClose = document.querySelector('.pop_modal_close');

if (spanClose != null) {
  spanClose.addEventListener('click', function (e) {
    document.body.classList.remove('popcoinShow');

    let modal3 = document.querySelector('#popModal');
    modal3.style.display = 'none';

    document.querySelector('#pop-club-quick-buy3').disabled = false;
    removePopHash();
    renderPopPrices();
  })
}
